export default "{\n    \"emptyPlaceholder\": \"Sélectionner un membre du personnel\",\n    \"searchPlaceholder\": \"Rechercher par nom\"\n}\n"